import React from 'react';
import { Divider } from 'antd';
import { C } from '../../constants/design-tokens';

/**
 * Visual separator between groups of controls in a horizontal toolbar.
 * Uses Ant Design's Divider with vertical orientation.
 */

export const ToolbarSeparator: React.FC = () => (
  <Divider
    type='vertical'
    style={{
      width: '1px',
      height: '18px',
      background: C.border,
      margin: '0 4px',
      alignSelf: 'center'
    }}
  />
);
